import {Clickable, HStack, Icon, Text, ThemeIconKey, Show} from 'platform/foundation';
import {match} from 'ts-pattern';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {PayPerUseLeaderboardSort} from '../utils/sortLeaderboardUsers';

interface PayPerUseSortableHeaderProps extends RequiredTestIdProps {
  label: string;
  columnId: string;
  sort: PayPerUseLeaderboardSort;
  onSort: (columnId: string) => void;
}

const getSortIcon = (direction: PayPerUseLeaderboardSort['direction']): ThemeIconKey =>
  match(direction)
    .with('asc', () => 'navigation/arrow_upward' as const)
    .with('desc', () => 'navigation/arrow_downward' as const)
    .exhaustive();

export function PayPerUseSortableHeader(props: PayPerUseSortableHeaderProps) {
  const isActive = props.sort.columnId === props.columnId;

  return (
    <Clickable
      onClick={() => props.onSort(props.columnId)}
      data-testid={suffixTestId('sort', props)}
    >
      <HStack spacing={1} align="center">
        <Text size="small" alternative>
          {props.label}
        </Text>
        <Show when={isActive}>
          <Icon value={getSortIcon(props.sort.direction)} size={4} />
        </Show>
      </HStack>
    </Clickable>
  );
}
